<template>
  <section class="hero is-warning is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h1 class="Graphit-Bold introduction">
            {{ awardText.award_title }}
          </h1>
          <h2 class="subtitle Rational-Book">
            {{ awardText.award_description }}
          </h2>
          <div class="field is-grouped is-grouped-multiline">
            <div
              class="control"
              :key="awardpublication.id"
              v-for="awardpublication in awardspublications"
            >
              <b-tooltip
                position="is-top"
                multilined
                type="is-light"
                :label="awardpublication.project"
              >
                <div class="tags has-addons">
                  <span class="tag is-light responsive-tag">
                    {{ awardpublication.year }}
                  </span>
                  <span class="tag is-dark responsive-tag">
                    <b-icon v-if="awardpublication.type === 'type1'"
                      icon="star">
                    </b-icon>
                    <b-icon v-if="awardpublication.type === 'type2'"
                      icon="pencil">
                    </b-icon>
                    &nbsp;&nbsp;&nbsp;{{ awardpublication.title }}
                  </span>
                </div>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>

import { mapState } from 'vuex';

export default {
  name: 'Awards',
  computed: {
    ...mapState([
      'awardspublications',
    ]),
    awardText () {
      return this.$store.getters.getAwardText;
    }
  },
  async mounted() {
    await this.$store.dispatch('UPDATE_AWARDSPUBLICATIONS');

  },
};
</script>
